export default __webpack_public_path__ + "static/media/18-bombardier-plane.f0c3a5bc.jpg";